import React from 'react';
import { Add } from './styles';
import { MdAddCircle } from 'react-icons/md';

const AddButton = props => {
  const { add, onClick } = props;
  return (
    <Add data-testid="add-button" add={add} onClick={onClick}>
      <MdAddCircle />
      Agregar
    </Add>
  );
};

export default AddButton;
